import {Alert, Button, Grid, LinearProgress, Paper, Popper} from "@mui/material";
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import {green, grey} from "@mui/material/colors";
import {formatCents, useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import moment from "moment";
import {useContext} from "react";
import {css} from "@emotion/css";
import {CostHelperContext} from "./CostHelperContext";
import {useEventEmitter} from "../../../../misc/UseEventEmitter";
import {useProjectId} from "../ProjectName";
import {projectLabel} from "../../../../api/Projects";

export function CostHelper() {
    const ctx = useContext(CostHelperContext);
    const value = useEventEmitter(ctx.value);
    const project = useProjectId();
    const product = value?.product || 0;
    const prepKind = ["door-prep", "frame-prep"].includes(value?.productType || "") ? value?.productType : undefined;
    const prepName = prepKind ? value?.itemName : undefined;

    const data = useAsync2(async (input: Parameters<typeof api.pricing.getCostInOtherQuotes>[0]) => {
        if(!input.product) return [];

        return api.pricing.getCostInOtherQuotes(input)
    }, {
        product: product,
        project: project,
        itemName: prepName || undefined,
    }, [product, project, prepName]);

    return (
        <Popper open={!!value} style={{ position: 'fixed', bottom: 10, right: 10, top: 'unset', left: 'unset', zIndex: 1000 }}>
            <Paper elevation={3}>
                <div style={{padding: 8, minWidth: 300}}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <div style={{fontSize: "0.75rem"}}>Cost Helper</div>
                            <div style={{fontSize: "0.6rem", color: grey["700"]}}>Costs used in recent quotes</div>
                        </Grid>
                        <Grid item style={{color: green["700"]}}>
                            <LightbulbOutlinedIcon color="inherit" />
                        </Grid>
                    </Grid>
                </div>

                <div style={{borderTop: "1px solid " + grey["200"]}}>
                    {data.loading ? <LinearProgress /> :
                        data.error ? <Alert color="error">
                                <div>{data.error}</div>
                                <Button onClick={data.reload}>Retry</Button>
                            </Alert> :
                        <>
                            {data.asList.map(rw => (
                                <div className={rowClass} onClick={() => {
                                    ctx.onSelectPrice(rw)
                                }}>
                                    <div style={{
                                        display: "flex",
                                    }}>
                                        <div>${formatCents(rw.avgUnitCostCents)}</div>
                                        <div>&nbsp;with&nbsp;</div>
                                        <div>{rw.avgMarkupPercent?.toFixed(0) || ""}% markup</div>
                                    </div>

                                    <div style={{color: grey["700"], fontSize: "0.75rem"}}>
                                        {projectLabel({projectNumber: rw.projectNumber, name: rw.projectName})} - {moment(rw.date).format("MMM D, YYYY")}
                                    </div>

                                </div>
                            ))}
                            {data.asList.length === 0 && <div style={{backgroundColor: grey["100"], padding: 4, textAlign: "center", fontSize: "0.8rem",color: grey["800"]}}>No results</div>}
                        </>}
                </div>
            </Paper>
        </Popper>
    );
}

const rowClass = css({
    fontSize: "0.9rem",
    padding: 4,
    paddingLeft: 8,
    paddingRight: 8,
    borderBottom: "1px solid " + grey["200"],
    cursor: "pointer",

    "&:hover": {
        backgroundColor: grey["200"],
    }
})